import { useEffect } from "react";

export default function DropdownClickOutside(ref, handler, exceptionRef) {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (
        !ref?.current ||
        ref?.current?.contains(event.target) ||
        !exceptionRef?.current ||
        exceptionRef?.current?.contains(event.target)
      ) {
        return;
      }
      handler && handler(event);
    };
    if (document) {
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
    }

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler, exceptionRef]);
}
